import { InjectionToken } from "@angular/core";
import { PaymentBatchesPort } from "./payment-batches.port";

export const TREASURY_PAYMENT_BATCHES_PORT =
  new InjectionToken<PaymentBatchesPort>("TREASURY_PAYMENT_BATCHES_PORT");
